<template>
  <div>
    <v-divider v-if="!isEviction" class="mt-2 mb-5" />

    <!-- total -->
    <div class="total">
      <h4 class="subtitle-2 text-center mb-2">
        {{ $t('quote.priceTable.payment') }}
      </h4>

      <!-- FCI presentation -->
      <div v-if="payWithFci">
        <h3 class="text-center">
          {{
            formatMoney(
              quoteItems.net_fci
                ? quoteItems.net_fci
                : quoteItems.subtotal
            )
          }}
        </h3>
        <span class="d-block text-center caption">
          {{$t('quote.priceTable.usingFCI')}}
        </span>
      </div>
      <!-- /FCI presentation -->

      <!-- eviction presentation -->
      <div v-if="isEviction">
        <h3 class="text-center">
          {{ formatMoney(quoteItems.total) }}
        </h3>
        <span class="d-block text-center caption">
          {{$t('quote.priceTable.usingBalance')}}
        </span>
      </div>
      <!-- /eviction presentation -->

      <!-- normal presentation -->
      <v-row v-if="!payWithFci && !isEviction"  class="mt-4" no-gutters>
        <v-col>
          <h3 class="text-center">
            {{ formatMoney(quoteItems.total_by_installments) }}
          </h3>
          <span class="d-block caption text-center">
            {{ $t('quote.priceTable.installments', { installments: installmentNumber }) }}
          </span>
        </v-col>
        <v-col class="text-center" cols="1">
          <v-divider vertical />
        </v-col>
        <v-col>
          <h3 class="text-center">
            {{ formatMoney(quoteItems.total) }}
          </h3>
          <span class="d-block text-center caption">
            {{ $t('quote.priceTable.discountPIXHint') }}
            <span class="green--text text-center">
              ( {{ formatMoney(quoteItems.cash_discount) }} )
            </span>
          </span>
        </v-col>
      </v-row>
      <!-- /normal presentation -->
    </div>
    <!-- /total -->
  </div>
</template>

<script>
import { catalogMonetary } from '@/util/catalog'

export default {
  name: 'QuotePricesTotal',

  props: {
    quotes: {
      type: Object,
    },

    quoteItems: {
      type: Object,
    },

    isEviction: {
      type: Boolean,
    },

    payWithFci: {
      type: Boolean,
    },
  },

  methods: {
    generateInstallments() {
      if (!this.quotes?.total_by_installments) {
        this.installmentNumber = 1
        return
      }

      for (let i = 1; i <= 10; i++) {
        if (this.quotes?.total_by_installments <= 5) {
          installmentNumber = 1
          return
        }

        if (Math.floor(this.quotes?.total_by_installments / i) > 5) {
          this.installmentNumber += 1
        }
      }
    },
  },

  data() {
    return {
      formatMoney: catalogMonetary,
      installmentNumber: 0,
    }
  },

  mounted() {
    this.generateInstallments()
  }
}
</script>
